import classNames from "classnames"
import React from "react"

import { Label2, Paragraph2 } from "@bounce/design-system"
import { useTranslation } from "@bounce/i18n"
import { Dropdown, DropdownItem } from "@bounce/web-components"

import CheckIcon from "@bounce/assets/icons/Check.svg"

export type StoreOrderByTagProps = "rating" | "relevance"

export type CityListViewOrderSelectorProps = {
  storeOrderTags: StoreOrderByTagProps[]
  currentStoreOrderBy: StoreOrderByTagProps
  onOrderChange: (orderBy: StoreOrderByTagProps) => void
  className?: string
}

export const CityListViewOrderSelector = ({
  storeOrderTags,
  currentStoreOrderBy,
  onOrderChange,
  className,
}: CityListViewOrderSelectorProps) => {
  const { t } = useTranslation("marketing-ls-city")

  const storeOrderByToLabel = {
    rating: t("screen.cityListViewScreen.cmp.orderSelector.rating", "By highest rating"),
    relevance: t("screen.cityListViewScreen.cmp.orderSelector.relevancy", "By most relevant"),
  }

  const currentLabel = storeOrderByToLabel[currentStoreOrderBy]

  return (
    <Dropdown
      className={classNames("border-0", className)}
      chevronClassName="text-neutral-800"
      buttonClassName="pr-0"
      pickerClassName="border-neutral-300 mt-0"
      id="city-list-view-order-selector"
      label={<Label2 className="!text-sm !font-medium text-neutral-800">{currentLabel}</Label2>}>
      {storeOrderTags.map(storeOrderBy => {
        const label = storeOrderByToLabel[storeOrderBy]
        const isSelected = storeOrderBy === currentStoreOrderBy

        return (
          <DropdownItem
            as="a"
            key={storeOrderBy}
            onClick={() => onOrderChange(storeOrderBy)}
            className="whitespace-nowrap border-t-0 text-sm text-neutral-900">
            {isSelected ? (
              <div className="flex w-full flex-row items-center justify-between">
                <Label2 className="mr-4 !text-sm">{label}</Label2>
                <CheckIcon />
              </div>
            ) : (
              <Paragraph2 className="!text-sm">{label}</Paragraph2>
            )}
          </DropdownItem>
        )
      })}
    </Dropdown>
  )
}
